import { jsx, jsxs } from "react/jsx-runtime";
import { Card, CardActionArea, ListItem, alpha, cardActionAreaClasses } from "@mui/material";
import { useWormhole } from "../../hooks/hooks/useWormhole/useWormhole.js";
import { AppLauncherCardContextProvider, useAppLauncherCard } from "./AppLauncherCardContextProvider.js";
import { useAppLauncherCardList } from "./AppLauncherCardList/AppLauncherCardListContextProvider.js";
const hasDisabledActionArea = `.${cardActionAreaClasses.root}:disabled`;
const focusVisible = `.${cardActionAreaClasses.focusVisible}`;
const actionable = `:hover:not(:has(${hasDisabledActionArea})), :has(${focusVisible})`;
const hasFocusedActionArea = `:has(${focusVisible})`;
const styleOverrides = (theme) => ({
  border: `1px solid ${theme.vars.palette.grey[300]}`,
  width: "100%",
  [actionable]: { boxShadow: 4 },
  [hasFocusedActionArea]: { backgroundColor: alpha(theme.palette.primary.main, 0.12) },
  [hasDisabledActionArea]: { backgroundColor: theme.vars.palette.grey[100] }
});
function CardComponent(props) {
  const { children, onClick, testId, showDescription = true } = props;
  const { cardId, disabled } = useAppLauncherCard();
  const { worms: header } = useWormhole(`${cardId}-cardHeader`);
  const { worms: description } = useWormhole(`${cardId}-cardDescription`);
  const { worms: actions } = useWormhole(`${cardId}-cardActions`);
  return /* @__PURE__ */ jsx(ListItem, { "data-tidal": "TidalAppLauncherCard", "data-testid": testId, sx: { paddingY: 0.5 }, children: /* @__PURE__ */ jsxs(Card, { elevation: 0, sx: styleOverrides, "data-testid": "appLauncherCardRoot", "data-cardid": cardId, "data-test": testId, children: [
    /* @__PURE__ */ jsxs(CardActionArea, { "data-testid": "appLauncherCardActionArea", onClick, disabled, children: [
      header,
      showDescription && description
    ] }),
    actions,
    /* @__PURE__ */ jsx("div", { hidden: true, "aria-hidden": true, children })
  ] }) });
}
function AppLauncherCard(props) {
  const { cardId, disabled, ...cardProps } = props;
  const { showDescriptions } = useAppLauncherCardList();
  return /* @__PURE__ */ jsx(AppLauncherCardContextProvider, { cardId, disabled, children: /* @__PURE__ */ jsx(CardComponent, { showDescription: showDescriptions, ...cardProps }) });
}
export {
  AppLauncherCard
};
//# sourceMappingURL=AppLauncherCard.js.map
